import { gql } from '@apollo/client'
import { ADMIN_STORE_FRAGMENT } from '../fragments'

export const GET_ADMIN_COMPANY_STORES = gql`
  query AdminCompanyStores($input: AdminCompanyStoresInput!) {
    adminCompanyStores(input: $input) {
      hasMore
      count
      results {
        ...AdminStore
      }
    }
  }
  ${ADMIN_STORE_FRAGMENT}
`
